import { render } from "./booking-detail.vue?vue&type=template&id=acc96aa0"
import script from "./booking-detail.vue?vue&type=script&lang=js"
export * from "./booking-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__